import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';
import Layout from './components/Layout';
import Home from './pages/Home';
import School from './pages/School';
import NotFound from './pages/NotFound';
import Timetable from './pages/Timetable';
import { ToastContainer } from 'react-toastify';
import ConfirmEmail from './pages/OfficeHours/ConfirmEmail';
import CancelAppointment from './pages/OfficeHours/CancelAppointment';
import { hotjar } from 'react-hotjar';
import WarningDialog from './components/dialog/WarningDialog';


if (process && process.env.NODE_ENV === 'production') {
    const trackingId = 'UA-158583633-1';
    ReactGA.initialize(trackingId, { gaOptions: { siteSpeedSampleRate: 100 } });
    ReactGA.pageview(window.location.pathname + window.location.search);

    if (!window.location.origin.includes('test') && !window.location.origin.includes('localhost'))
        hotjar.initialize(2302778, 6);
}


const App: React.FC = () => {


    return (
        <Router>
            <ToastContainer />
            <Layout>
                <WarningDialog />
                <Switch>
                    <Route path='/cancel'>
                        <CancelAppointment />
                    </Route>
                    {/*<Route path='/confirmEmail'>*/}
                    {/*    <ConfirmEmail />*/}
                    {/*</Route>*/}
                    <Route path='/notfound'>
                        <NotFound />
                    </Route>
                    <Route path='/:school/:type/:termSchoolID/:ID'>
                        <Timetable />
                    </Route>
                    <Route path='/:school'>
                        <School />
                    </Route>
                    <Route path='/'> <Home /> </Route>
                </Switch>
            </Layout>
        </Router>
    );
};

export default App;
